import React, {useEffect} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../store/reducers";
import {CommonService} from "../../shared/services";

export interface AuthLayoutProps {

}

const AuthLayout = (props: React.PropsWithChildren<AuthLayoutProps>) => {

    const navigate = useNavigate();
    const location = useLocation();
    const {token} = useSelector((state: IRootReducerState) => state.account);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const roleCode = currentUser?.roleObj?.code;

    useEffect(() => {
        let returnUrl = roleCode === 'billing' ? CommonService._routeConfig.TestOrderListRoute() : CommonService._routeConfig.Dashboard();
        if (!!token) {
            const query = CommonService.parseQueryString(location.search);
            if (Object.keys(query).includes('returnUrl')) {
                returnUrl = query.returnUrl;
            }
            navigate(returnUrl);
        }
    }, [token, navigate, location, roleCode])

    return (
        <div className="auth-layout">
            <div className="auth-brand-banner">
                <div className="brand-title">AI LabX</div>
                <div className="brand-subtitle">Simplifying Lab Operations</div>
                <div className="brand-description">Automate and manage your lab seamlessly</div>
            </div>
            <div className="auth-wrapper position-relative">
                <div className="auth-form width-100">
                    <Outlet/>
                    <div className="copyright">© Copyright 2024 AdvanzInnovation. All rights reserved.</div>
                </div>
            </div>
        </div>

    )
}
export default AuthLayout;
